import { createContext, useContext, useState } from "react";

const RedirectContext = createContext()

export const RedirectProvider=({children})=>{

    const [redirectURL, setredirectURL] = useState(null)

    return(
        <RedirectContext.Provider value={{redirectURL,setredirectURL}}>
            {children}
        </RedirectContext.Provider>
    )
}

export const useRedirect=()=>{
    return useContext(RedirectContext)
}